import { ChartSettingsButton } from 'finviz-charts/app/controllers/chart-controls/settings-button'

import { Icon } from '../../../main/components/icon'
import { withSuspense } from '../../../main/services/async-modules-utils'
import { useChartLayoutGlobalModelAsync } from '../../charts-lib'

interface Props {
  isPremium: boolean
}

function ForexFuturesCryptoSettingsRaw({ isPremium }: Props) {
  const { chartLayoutModel } = useChartLayoutGlobalModelAsync()

  if (!chartLayoutModel) return null

  return (
    <ChartSettingsButton
      size="small"
      theme="transparent"
      className="-mr-1 text-gray-300 hover:text-gray-400"
      isPremium={isPremium}
      leftContent={<Icon name="settingsWheel" width={12} />}
      model={chartLayoutModel}
    />
  )
}

// charts bundle may not be fetched and therefore withSuspense is undefined but on those pages components in this file are not used at all
export const ForexFuturesCryptoSettings = withSuspense?.(ForexFuturesCryptoSettingsRaw)
